const album = [
    {   id:1,
        title:"Soulful Symphony",
        image:require("../images/coverart1.png")
    },
    {     id:2,
        title:"Echoes of Euphoria",
        image:require("../images/coverart2.png")
    },
    {     id:3,
        title:"Aural Adventure",
        image:require("../images/coverart3.png")
    },
    {     id:4,
        title:"Aural Adventure",
        image:require("../images/coverart4.png")
    },
]

export default album